export default {
  sorry: 'Désolés',
  sorryClass: "Désolé, nous n'avons pas pu trouver de prix en ",
  weFound: "nous n'avons trouvé ",
  noResults: 'aucun résultat',
  fares: '',
  theseDates: ' pour ces dates.',
  matchingSearch: 'correspondant à votre recherche.',
}
